"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiGetAdminMetrics = void 0;
const client_1 = require("./client");
const util_1 = require("./util");
const apiGetAdminMetrics = async () => {
    try {
        const { data } = await client_1.default.get('/admin/');
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiGetAdminMetrics = apiGetAdminMetrics;
//# sourceMappingURL=admin.js.map